<tcc-mono-dialog-layout [title]="'Export vanaf houder '" (onSave)="save()">
  <form [formGroup]="form" (ngSubmit)="save()">
    <ion-input
      mode="md"
      formControlName="date"
      labelPlacement="stacked"
      fill="solid"
      errorText="Datum is verplicht"
      type="date"
    >
      <ion-text slot="label" class="form-label required"> Datum </ion-text>
    </ion-input>
  </form>
</tcc-mono-dialog-layout>
